<template>

  <div v-if="userId != 0" class="flex flex-col items-center w-full border-blue-800 border-8 p-2 lg:p-8">

        <ring-loader v-if="showLoader"></ring-loader>

        <div class="flex justify-center items-center mt-10 mb-10 w-full px-2 lg:pl-20">

            <label class="mr-2 lg:mr-5"><strong>{{$t('profile.profilePicture')}}: </strong></label>

            <button   class=" text-center rounded-lg p-5 bg-pink-400" @click="onFileButtonClicked">{{$t('profile.uploadImage')}}</button>

            <circle-loader v-if="isLoadingImage"></circle-loader>

                <img :src="user.picture" class="ms-5 rounded-lg" height="100" ref="playerImageRef" width="100"/>

            <input type="file"  accept="image/*" style="display: none;" ref="fileInput" @change="getImageEvent">
      </div>

      <div class="flex justify-center items-center mt-2 lg:mt-10 mb-2 lg:mb-10 w-full">
                     
        <label class="mr-5"><strong>{{$t('player.playerName')}}  </strong></label>
        
        <input v-model="playerName"
        class=" bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4
            block appearance-none leading-normal text-center w-32 lg:w-64"
            type="text" placeholder="Pitch Name" @change="inputChanged">
      </div>

      <div>

        <label class="ml-2 bg-green-600" v-if="nameStatus == 1"><strong>{{$t('player.nameAvailable')}}  </strong></label>
        
        <label class="ml-2 bg-red-600" v-else-if="nameStatus == 2"><strong>{{$t('player.nameNotAvailable')}}  </strong></label>
      </div>

      <div class="flex justify-center items-center mt-2 lg:mt-10 mb-2 lg:mb-10 w-full">
                     
        <label class="mr-5"><strong>{{$t('profile.phone')}}  </strong></label>
        
        <input v-model="phone"
        class=" bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-lg py-2 px-4
            block appearance-none leading-normal text-center w-32 lg:w-64"
            type="tel" placeholder="Player Phone">
      </div>

    <div class="w-full">

        <div class="mb-2 mt-6">

            <label>{{$t('player.justFootball')}}</label>
        </div>
        
        <div class="flex flex-row justify-around w-full">
            
            <div>
                
                <div>

                    <label>{{$t('player.firstPosition')}}</label>
                </div>

                <div class="">
                                    
                    <vue-multi-select
                    v-model="firstPositionOptionsProxy"
                    :btnLabel="btnLabelOne"
                    :position="positionOne"
                    :options="options"
                    @input="firstPositionOptionsSelection"
                    :selectOptions="firstPositionOptions"/>
                </div>
            </div>

            <div>

                <div>

                    <label>{{$t('player.secondPosition')}}</label>
                </div>

                <div class="">
            
                    <vue-multi-select
                    v-model="secondPositionOptionsProxy"
                    :btnLabel="btnLabelTwo"
                    :position="positionTwo"
                    :options="options"
                    @input="secondPositionOptionsSelection"
                    :selectOptions="secondPositionOptions"/>
                </div>
            </div>
      </div>
    </div>
      
      
      <div  class="items-center mb-1 lg:mb-4">

        <button @click="uploadFileToFireBase"
          :disabled="isLoadingImage || showLoader"

        class="mt-5 lg:mt-30 w-24 lg:w-48  rounded bg-pink-500 text-white font-bold p-2 lg:p-4 uppercase border-blue-500 border">
        {{$t('profile.submit')}} </button>
      </div>
  </div>
  <div v-else class="mt-4">

        <div>
            <label><strong>{{$t('business.profileFirst')}}</strong></label>
        </div>

        <div class="mt-6">
            <button 
            class="w-48 lg:rounded-lg rounded bg-pink-500 text-white text-sm 
            lg:text-md font-bold h-6 lg:h-12 border-blue-500 border text-center p-1"
            @click="$router.push({ name: 'profile'});
            "> {{$t('profile.goToProfile')}}</button>
        </div>
    </div>
</template>

<script>

import firebase from '../classes/firebase';

import vueMultiSelect from 'vue-multi-select'; 
import 'vue-multi-select/dist/lib/vue-multi-select.css';

import { RingLoader } from 'vue-spinners-css';
import { CircleLoader } from 'vue-spinners-css';

import twoMyInserts from '../hasura/myTwoInserts';

import twoMyQueries from '../hasura/myTwoQueries';


import componentsHelpers from '../classes/componentHelpers';

export default {

    created(){

        // console.log(`in player - form`);
        this.initialPositionsOptions = this.footballPositions.filter(item=> item);

        this.firstPositionOptions = this.initialPositionsOptions.filter(item=> item);
        this.secondPositionOptions = this.initialPositionsOptions.filter(item=> item);
    },

    mounted(){
    
    this.phone = this.user.phone;
    // console.log(`user: ${JSON.stringify(this.user)}`);

    // console.log(`initialPositionsOptions: ${JSON.stringify(this.initialPositionsOptions)}`); 
  },

    props:{
        
        footballPositions:{

            type: Array
        },

        myReload:{

            type: Function
        },

        userId: 0,

        user:{

            type: Object
        },

        email:''
    },

    components:{

       vueMultiSelect 
    },

    methods:{

        callReload(){

            this.myReload();
        },

        inputChanged(){

            this.isNameAvailable(this.playerName);
        },

        async isNameAvailable(name){

            const apollo = this.$apollo;

            const toast = this.$toasted;

            let userId = this.userId;
            
            try{

                this.showLoader = true;

                let playerNameQuery = await this.$apollo.query({

                    query: twoMyQueries.player_name_query,

                    variables: {
                
                        playerName: this.playerName
                    },

                    error(error){

                        this.allLoaded = false;

                        componentsHelpers.sendError(apollo, userId,'player', ',playerForm', 'isNameAvailable' , error);
                    
                        componentsHelpers.toastIt(toast, this.$t('home.errorToAdmin'), 3, 'outline', true);

                        // this.tokenError = JSON.stringify(error);
                    },   
                });

                this.showLoader = false;

                // console.log(` playerNameQuery: ${JSON.stringify(playerNameQuery)}`);

                if(playerNameQuery.data.two_player.length > 0){

                    componentsHelpers.toastIt(toast, this.$t('player.nameNotAvailable'), 3, 'outline', true);

                    this.nameStatus = 2;

                    return false;
                }
                else{

                    this.nameStatus = 1;

                    return true;
                }
            }catch(error){

                this.showLoader = false;

                console.log(`error: ${JSON.stringify(error)}`);

                componentsHelpers.sendError(apollo, userId,'player', ',playerForm', 'isNameAvailable-catchError' , error);

                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
            }
        },

       firstPositionOptionsSelection(selectedOption){
            
            // console.log(`in firstPositionOptionsSelection`);

            if(this.firstPositionOptionsProxy.length > 0){

                // this.secondPositionOptions = this.initialPositionsOptions.filter(item => item);

                // this.secondPositionOptions = this.removeItemAtIndex(this.secondPositionOptions, this.firstPositionOptionsProxy[0].id);
            }
            else{

                this.firstPositionOptionsProxy.push(this.initialPositionsOptions[0]);
            }
        },

        secondPositionOptionsSelection(selectedOption){
            
            // console.log(`in secondPositionOptionsSelection`);

            if(this.secondPositionOptionsProxy.length > 0){

                    // this.firstPositionOptions = this.initialPositionsOptions.filter(item => item);
                // this.firstPositionOptions = this.removeItemAtIndex(this.firstPositionOptions, this.secondPositionOptionsProxy[0].id);
            }
            else{

                this.secondPositionOptionsProxy.push(this.initialPositionsOptions[0]);
            }
        },

        removeItemAtIndex(array, id){

            let index = array.findIndex(function(object){
                return object.id === id
            })
            if (index !== -1) array.splice(index, 1);

            return array
        },

        async checkForm(){

            if(this.playerName == ''){

                componentsHelpers.toastIt(toast, this.$t('player.playerNameEmpty'), 3, 'outline', true);

                return false;
            }
            else if(!this.phone || this.phone === '' || this.phone.length < 8){
                
                componentsHelpers.toastIt(this.$toasted, this.$t('profile.phoneDigitsAlert'), 3, 'outline', true);
                return false;
            }
            else{

                const isNameAvailable = await this.isNameAvailable();

                if(isNameAvailable == false){

                    return false;
                }
                else{

                    return true;
                }
            }
        },

        async createPlayerMutate(){

            if(!await this.checkForm()){

                return;
            }

            let playerInsertResult;

            try{

                let img = this.$refs.playerImageRef;

                const apollo = this.$apollo;

                const toast = this.$toasted;   

                const t = this.$t;

                // console.log(`$userId: ${JSON.stringify(this.$userId)}`);

                // console.log(`userId: ${JSON.stringify(this.userId)}`);

                playerInsertResult = await this.$apollo.mutate({

                    mutation: twoMyInserts.player_insert,

                    variables: {

                        nickname: this.playerName,
                        picture: img.src,
                        userId: this.$userId,
                        phone: this.phone,
                        firstPositionId: this.firstPositionOptionsProxy[0].id,
                        secondPositionId: this.secondPositionOptionsProxy[0].id

                        // typeId: userType
                    },
                        
                    error(error){

                        this.showLoader = false;
                        this.mutationError = error;

                        // if(this.mutationError.includes('unique constraint "user_phone_key"'))
                        // {
                        
                        // // alert (`Error: Phone is already registered`);
                        // }
                        // console.log(`Fayez Error is ${JSON.stringify(error)}`);

                        componentsHelpers.sendError(apollo, 0, 'Player', 'playerForm', 'createPlayerMutate',
                        error);

                        componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
                    }
                    });

                    componentsHelpers.toastIt(this.$toasted, this.$t('player.profileCreated'),
                     2,'bubble', true);

                    if(playerInsertResult.data.insert_two_player.affected_rows == 1){

                        const reload = this.callReload;

                        setTimeout(function(){

                            reload();
                        }, 3000);
                    }
                }
                catch(error){

                this.showLoader = false;

                componentsHelpers.sendError(this.$apollo, 0, 'Player', 'playerForm', 'createPlayerMutate-catchError', error);

                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

                this.mutationError = error;

                // if(this.mutationError.message.includes('unique constraint "user_phone_key"'))
                // {

                //         componentsHelpers.sendError(this.$apollo, 0,'Profile', 'ProfileForm', 'signUpMutate',
                //     `Error: Phone is already registered: ${phone}`);
                //         componentsHelpers.toastIt(this.$toasted, this.$t('profile.phoneAlreadyRegisteredError'), 3, 'outline', true);
                // }
            }
        },

        onFileButtonClicked(){

            this.$refs.fileInput.click();
        },

        getImageEvent(event){

            let img = this.$refs.playerImageRef;

            const fileReader = new FileReader();
            
            fileReader.addEventListener('load', () => {

                img.src = fileReader.result
                this.isLoadingImage = false;
            });
        

            const apollo = this.$apollo;

            const toast = this.$toasted;

            const t = this.$t;

            fileReader.onerror = function(event) {

                componentsHelpers.sendError(apollo, 0,'Player', 'playerForm', 'getImageEvent', this.$t('profile.loadedImageError'));

                componentsHelpers.toastIt(toast, this.$t('profile.loadedImageError'), 3, 'outline', true);
                
                this.isLoadingImage = false;

            };
            
            if(event.target.files.length > 0){

                this.imageFile = event.target.files[0];

                this.isLoadingImage = true;
                fileReader.readAsDataURL(this.imageFile);
            }
        },


        uploadFileToFireBase(){
        
            let img = this.$refs.playerImageRef;

            const submitFunction = this.createPlayerMutate;

            let getFile = this.imageFile;

            if(this.checkForm())
            {

                if(getFile != null){

                let fileExtension = getFile.name.substr(getFile.name.lastIndexOf('.'));
                //set storage ref

                // const targetLocation = 'p-nadi/images/'+this.email + `(User)/${this.email + ' PC ' + new Date().getTime()+ fileExtension}`;
                const targetLocation = 'p-nadi/images/'+ this.email + `(User)/player`  + `${fileExtension}`;

                // console.log(`Target location is ${targetLocation}`);

                let storageRef = firebase.storage().ref(targetLocation);

                // console.log(`storageRef is ${storageRef}`);
                
                this.isLoadingImage = true;
                let task = storageRef.put(getFile);

                // const componentsHelpers = componentsHelpers;

                const apollo = this.$apollo;

                const toast = this.$toasted;

                const t = this.$t;

                task.on('state_changed',
                    function progress(snapshot){
                    let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;

                    // this.uploadingPercentage = percentage + '%';
                    
                    // this.uploadingPercentage = this.uploadingPercentage + 10;

                    this.isLoadingImage = false;

                    // console.log(`percentage is ${percentage}`);
                    },
                    function error(err){
                    // console.log(err);

                    componentsHelpers.sendError(apollo, 0,'Group', 'createGroup', 'uploadFileToFireBase - task.on-1', error);

                    componentsHelpers.toastIt(toast, this.$t('profile.loadedImageError'), 3, 'outline', true);

                    // alert('Image could not be loaded');

                    this.isLoadingImage = false;
                    },
                    function complete(res){
                    //  console.log(`complete upload with ${res}`);
                    

                    // console.log(`all url objects are ${task.snapshot.ref}`);
                    task.snapshot.ref.getDownloadURL().then((url)=>{
                        
                        this.isLoadingImage = false;

                        this.picture = url.toString();

                        img.src = this.picture;

                        // console.log(`Img source is ${this.picture}`);

                        submitFunction();

                    });
                    }
                );
                
                // const componentsHelpers = componentsHelpers;

                // const apollo = this.$apollo;

                // const toast = this.$toasted;

                task.then(snapshot => {
                    this.isLoadingImage = false;
                }).catch(error => {

                    this.isLoadingImage = false;

                    componentsHelpers.sendError(apollo, 0,'group', 'createGroup', 'uploadFileToFireBase - task.on-2', error);

                    componentsHelpers.toastIt(toast, this.$t('profile.errorOccured'), 3, 'outline', true);
                    // alert('Error has occured. Try again later');
                });
                }
                else{

                submitFunction();
                } 
            }
        }
    },

    data(){

        return{
            
            playerName: '',
            isLoadingImage: false,
            picture: '',
            phone: '',
            nameStatus: 0,
            showLoader: false,
            initialPositionsOptions:[],
            firstPositionOptions: [],
            firstPositionOptionsProxy: [],
            secondPositionOptions: [],
            secondPositionOptionsProxy: [],

            btnLabelOne: values => this.firstPositionOptionsProxy.length > 0 ?  (this.$i18n.locale == 'ar'? this.firstPositionOptionsProxy[0].name_ar : this.firstPositionOptionsProxy[0].name) : `${this.$t('player.playerPosition')} #1` ,

            btnLabelTwo: values => this.secondPositionOptionsProxy.length > 0 ? (this.$i18n.locale == 'ar'? this.secondPositionOptionsProxy[0].name_ar : this.secondPositionOptionsProxy[0].name) : `${this.$t('player.playerPosition')} #2`,


            positionOne: this.$i18n.locale == 'ar'?  'bottom-right' :  'bottom-left',

            positionTwo: this.$i18n.locale == 'ar'? 'bottom-left' :  'bottom-right',

            options: {
                
                multi: false,

                labelName: this.$i18n.locale == 'ar' ? 'name_ar': 'name',

                cssSelected: option => (option.selected ? { 'background-color': '#5764c6' } : ''),
            },

        }
    }
}
</script>

<style>

</style>